/**
 * Shared by the webhooks list (Webhooks.tsx) and the endpoint page
 * (WebhookEdit.tsx) — the same split tool-form.ts serves for tools.
 * `hostOf` is deliberately NOT duplicated here; import it from tool-form.
 */
import { ApiError } from '@/api'

/** The conflict codes these screens can provoke, as sentences with a next
 *  action. Anything else is the server's own message, verbatim. */
export function webhookMessageFor(e: unknown): string {
  if (!(e instanceof ApiError)) return e instanceof Error ? e.message : String(e)
  switch (e.code) {
    case 'read_only':
      return 'Your role can read this but not change it.'
    case 'bad_url':
      return `That URL was refused: ${e.message}`
    case 'webhook_limit':
      return e.message
    case 'revoked':
      return 'This endpoint was revoked (possibly from another tab) and cannot be edited or tested.'
    case 'no_such_webhook':
      return 'No webhook endpoint has that id. It may never have existed — check the link.'
    case 'bad_field':
      return `The server refused a field: ${e.message}`
    default:
      return e.message
  }
}
